import type { Booking } from '../services/booking.api';

/**
 * A specific, human-readable title for a booking — never just the generic
 * service type ("Appliance Repair"). Prefers the asset it's for, so the user
 * sees e.g. "LG Microwave · Appliance Repair" instead of a vague label.
 */
export function bookingTitle(
  b: Pick<Booking, 'serviceType' | 'asset' | 'diagnosisIssue'>,
): string {
  const service = (b.serviceType || 'Service').replace(/_/g, ' ').trim();
  const asset = b.asset?.name?.trim();
  if (asset) return `${asset} · ${service}`;
  // No asset linked — fall back to the diagnosed issue, then the service type.
  if (b.diagnosisIssue?.trim()) return b.diagnosisIssue.trim();
  return service;
}
